import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationEN from "./public/locales/en/translation.json";
import translationFR from "./public/locales/fr/Translation.json";
import translationAR from "./public/locales/ar/Translation.json";

// the translations
const resources = {
  en: {
    common: translationEN,
  },
  de: {
    common: translationFR,
  },
  ar: {
    common: translationAR,
  },
};
i18n.use(initReactI18next).init({
  resources,
  lng: "de",
  fallbackLng: ["de"],
  keySeparator: false, // we do not use keys in form messages.welcome
  interpolation: {
    escapeValue: false, // react already safes from xss
  },
});
export default i18n;
